import mitt from "mitt";

export const eventBus = globalThis.caiEventBus ||= mitt();
